<!--Action-->
<action class="w-12-s cursor-pointer"
        sizeClass="S: button-1"
        (click)="logout()"
        [status]="logoutStatus"
        sl-button="logout"
        cy-logoutBtn>
    <span class="flex flex-middle button__body">
        <i *ifSize="'!S'"
           style="font-size: 1.2rem;"
           class="icon-logout m-r-5 inline-flex"></i>
        <span translate
              sizeClass="!S: fw-medium">Sign out</span>
    </span>
</action>

<result [status]="logoutStatus"
        sl-result="logout"
        class="block m-t-1"></result>